module.exports = __webpack_public_path__ + "static/media/onboarding-image-v2.ca03df8c.png";